export default function getEstimateItemGoal(itemXmlId, mode = 'short', isSubmit = false) {
    if (!itemXmlId) return;
    if (mode !== 'short' && mode !== 'full') return;

    let modeStr = mode === 'short' ? 'bystraya_ocenka' : 'podrobnaya_ocenka';
    let goalTarget = '';

    switch (itemXmlId) {
        case 'gold': {
            goalTarget = 'zoloto';
            break;
        }
        case 'Silver': {
            goalTarget = 'serebro';
            break;
        }
        case 'sport_inventory': {
            goalTarget = 'sport_inventar';
            break;
        }
        case 'watch': {
            goalTarget = 'chasy';
            break;
        }
        case 'Fur_coats': {
            goalTarget = 'meh';
            break;
        }
        case 'antiques': {
            goalTarget = 'antikvariat';
            break;
        }
        case 'gadgets': {
            goalTarget = 'gadzhety';
            break;
        }
        case 'mechanism': {
            goalTarget = 'tehnika';
            break;
        }
        case 'computers': {
            goalTarget = 'kompyutery';
            break;
        }
        case 'other': {
            goalTarget = 'prochee';
            break;
        }
    }

    let goalStrTuple = ['vybor_vid_zaloga', goalTarget, modeStr];

    if (isSubmit) {
        goalStrTuple.push('i_otpravka_formy');
    }

    return goalStrTuple.join('_');
}